import PriceBadge from './PriceBadge';

export default PriceBadge;
